import { render } from "./NvarWeb.vue?vue&type=template&id=37535338"
import script from "./NvarWeb.vue?vue&type=script&lang=js"
export * from "./NvarWeb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__